module.exports = __webpack_public_path__ + "img/not-uploaded.427d71b3.svg";